import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { MMU_GLOBAL_PRIVACY_CONTROL } from '../../injection-tokens/mmu-global-privacy-control.token';
import { MMU_SUBSIDIARY_COOKIE_NAME } from '../../injection-tokens/mmu-subsidiary-cookie-name.token';
import { MmuCookiePreferences } from '../mmu-cookie-preferences';


@Component({
  selector: 'mmu-ff-ent-gtm-tracking-cookie-selection',
  templateUrl: './mmu-cookie-selection.component.html',
  styleUrls: ['./mmu-cookie-selection.component.scss']
})
export class MmuFFEntGTMTrackingCookieSelectionComponent implements OnInit {
  showGPCHint = false;

  @Input()
  settings: MmuCookiePreferences = {
    required: true,
    statistics: false
  };

  @Input()
  formDisabled = false;

  @Output()
  settingsChange: EventEmitter<MmuCookiePreferences> = new EventEmitter<MmuCookiePreferences>();

  private readonly gpcRequiredSubsidiaries = ['us'];
  private readonly subsidiary: string;

  constructor(
    @Inject(MMU_GLOBAL_PRIVACY_CONTROL) private gpcToken: boolean,
    @Inject(MMU_SUBSIDIARY_COOKIE_NAME) private readonly subsidiaryCookieName: string,
    private cookieService: CookieService
  ) {
    /** fall back to a subsidiary which requires GPC because that is the closest to our expected use case */
    this.subsidiary = this.cookieService.get(this.subsidiaryCookieName) ?? 'us';
  }

  valueChanged(property: keyof MmuCookiePreferences, value: boolean): void {
    this.settings[property] = value;
    this.settingsChange.emit(this.settings);
  }

  ngOnInit(): void {
    if (this.gpcRequiredSubsidiaries.includes(this.subsidiary)) {
      this.showGPCHint = true;
    }

    this.globalPrivacyControlForUSSubsidiary();
  }

  globalPrivacyControlForUSSubsidiary(): void {
    if (this.gpcToken) {
      this.settings.statistics = false;
    }
    this.settings.statistics = this.subsidiary === 'us' && this.gpcToken === false;
  }
}
